var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Duel_Component',{staticClass:"loading-blur",attrs:{"duel":_vm.fakeDuel}})}
var staticRenderFns = []

export { render, staticRenderFns }